export default "__VITE_ASSET__UoAT5l14__"